// extracted by mini-css-extract-plugin
export default {"AISaasShare":"AISaasApp_AISaasShare__EN5Ba","account":"AISaasApp_account__vTACN","saas-content":"AISaasApp_saas-content__5COfR"};